export default __webpack_public_path__ + "static/media/la_ferte-vidame04.02a87682.jpg";